import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useI18n } from "../i18n";

export const SiteFooter = () => {
  const { t } = useI18n();

  return (
    <footer className="border-t border-white/10 bg-[#08080a]" data-testid="site-footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-md">
          <Link to="/" data-testid="footer-brand-link" className="flex items-center gap-2 group">
            <ShieldCheck className="h-4 w-4 text-sky-400 transition-colors group-hover:text-sky-300" strokeWidth={1.75} />
            <span className="font-head text-[14px] font-semibold tracking-tight">
              AIwatermark<span className="text-sky-400">.studio</span>
            </span>
          </Link>
          <p className="mt-3 text-xs leading-relaxed text-slate-500">{t("footer.privacyNote")}</p>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px] text-slate-400">
          <Link to="/studio" data-testid="footer-studio-link" className="transition-colors hover:text-white">
            {t("studio.title")}
          </Link>
          <a href="/blog/" data-testid="footer-blog-link" className="transition-colors hover:text-white">
            {t("footer.guides")}
          </a>
          <Link to="/legal" data-testid="footer-legal-link" className="transition-colors hover:text-white">
            {t("footer.legal")}
          </Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white">
            {t("footer.privacy")}
          </Link>
        </nav>
      </div>
      <div className="mx-auto max-w-6xl px-5 pb-8">
        <p className="font-mono2 text-[11px] text-slate-600">© {new Date().getFullYear()} AIwatermark.studio</p>
      </div>
    </footer>
  );
};
